import { createSlice } from "@reduxjs/toolkit";

const minimizeFloatterSlice = createSlice({
  name: "minimizeFloatterData",
  initialState: [],
  reducers: {
    setMinimizerData: (state, action) => {
      const checkForExistingEntry = state.find((item) => item.path == action.payload.path);
      if (!checkForExistingEntry) {
        const data = [...state, action.payload];
        return data.map((item, index) => ({
          ...item,
          index,
        }));
      }
      return state;
    },
    removeMinimizerData: (state, action) => {
      const data = [...state];
      data.splice(action.payload, 1);
      const result = data.map((record, index) => ({ ...record, index }));
      return result;
    },
    emptyMinimizerData: () => [],
  },
});

export const { setMinimizerData, removeMinimizerData, emptyMinimizerData } = minimizeFloatterSlice.actions;

export const minimizeFloatterData = minimizeFloatterSlice.reducer;

export default minimizeFloatterSlice.reducer;
